import React, { useState, useCallback } from 'react';
import { Button, SelectList, Dialog, IDropDownItem } from '@framework-controls/core';
// import { strings } from 'src/helpers/localization';
import { strings } from 'src/localization';
import css from './VehicleCard.module.scss';
import { NewVehicle, ascCtaInteractionInput, ascMenuInteractionInput, ascElementConfigurationInput } from 'src/models';
import classNames from 'classnames';
import VehicleModelImages from 'src/components/VehicleImages/VehicleModelImages';
import VehicleMakeImages from 'src/components/VehicleImages/VehicleMakeImages';
import { IconRemove } from 'src/content/icons';
import { ascCtaInteraction, ascMenuInteraction, getElementColor, ascElementConfiguration } from 'src/helpers/EventHelper/EventHelper';
// import { lowerCase } from 'lodash';

interface IProps {
    id: string;
    click: (target: EventTarget | string) => void;
    options: NewVehicle;
    pane?: string;
    width?: string;
    height?: string;
    image?: HTMLImageElement;
    otherList?: string[];
    theme: string;
    defaultLen: number;
    Itype: string | undefined;
}


const VehicleCard = (props: IProps) => {
    const [otherProperty, setOtherProperty] = useState('default');
    const [menuOpenFlag, setMenuOpenFlag] = useState(false);
    const [background, setBackground] = useState('light');

    const [selectOpen, setSelectOpen] = useState(false);
    const { options, id, width, height, click, pane } = props;
    const { year, make } = options;
    // const transLit = lowerCase(id);
    let transLit = id;
    // For Porsche we have been requested to not displayu the make lit below their logo.
    // if (transLit === 'Porsche') {
    //     transLit = '';
    // }
    if (transLit === 'Ford Canada') {
        transLit = 'Ford';
    }
    if (transLit === 'Chrysler Canada') {
        transLit = 'Chrysler';
    }
    if (transLit === 'Cummins Mid-canada') {
        transLit = 'Cummins';
    }
    if (transLit === 'Vw Canada') {
        transLit = 'Volkswagen';
    }
    if (transLit === 'Bmwi') {
        transLit = 'BMW';
    }
    if (transLit === 'Honda Mtc/pp/pe') {
        transLit = 'Honda';
    }
    if (transLit === 'Discover Canada') {
        transLit = 'Discover';
    }

    const makeDropdownList: IDropDownItem[] = [];
    if (id === 'Other Make' && props.otherList && props.otherList.length > 0) {
        const listItemDefault: IDropDownItem = { label: '', value: 'default' };
        makeDropdownList.push(listItemDefault);
        // Iterate through props.otherList and add each item to makeDropdownList
        props.otherList.forEach((other) => {
            // Create a new IDropDownItem for each item in props.otherList
            let otherLit = other;
            if (other === 'Ford Canada') {
                otherLit = 'Ford';
            }
            if (other === 'Chrysler Canada') {
                otherLit = 'Chrysler';
            }
            if (other === 'Vw Canada') {
                otherLit = 'Volkswagen';
            }
            if (other === 'Bmwi') {
                otherLit = 'BMW';
            }
            if (other === 'Honda Mtc/pp/pe') {
                otherLit = 'Honda';
            }
            if (other === 'Cummins Mid-canada') {
                otherLit = 'Cummins';
            }
            if (other === 'Discover Canada') {
                otherLit = 'Discover';
            }

            const listItem: IDropDownItem = { label: otherLit, value: otherLit };

            // Add the new IDropDownItem to the makeDropdownList array
            makeDropdownList.push(listItem);
        });
    }

    const yearDropdownList: IDropDownItem[] = [];
    if (id === 'Other Year' && props.otherList && props.otherList.length > 0) {
        const listItem: IDropDownItem = { label: '', value: 'default' };
        yearDropdownList.push(listItem);
        props.otherList.forEach((other) => {
            const listItem: IDropDownItem = { label: '', value: '' };
            listItem.label = other;
            listItem.value = other;
            yearDropdownList.push(listItem);
        });
    }

    const othrLblStyle = classNames(
        {
            [css.lgOthrLbl]: id !== 'Other Year',
            [css.smlOthrLbl]: id === 'Other Year',
            [css.othrLblIN]: props.theme === 'infiniti',
            [css.othrLblMazda]: props.theme === 'mazda',
            [css.othrLblAcura]: props.theme === 'acura',
            [css.othrLblGenesis]: props.theme === 'genesis',
        },
    );

    const selectedOptions: string[] = Object.values(options);
    const defaultCardClicked: boolean = !!selectedOptions.find(element => element === id);
    const otherYrCardClicked: boolean = !!yearDropdownList.find(element => element.label === options.year && id === 'Other Year');
    const otherMkCardClicked: boolean = !!makeDropdownList.find(element => element.label === options.make && id === 'Other Make');
    const cardClicked: boolean = defaultCardClicked || otherYrCardClicked || otherMkCardClicked;

    let otherLabel = props.defaultLen === 0 && props.id === 'Other Make' ? strings.Choose : strings.Other;

    if (otherYrCardClicked && options.year) {
        otherLabel = otherLabel + ' - ' + options.year;
    }
    if (otherMkCardClicked && options.make) {
        let makeLit = options.make;
        if (makeLit === 'Chrysler Canada') {
            makeLit = 'Chrysler';
        }
        otherLabel = otherLabel + ' - ' + makeLit;
    }

    const cardStyle = classNames(
        css.card,
        {
            [css.cardClicked]: cardClicked,
            [css.smallCard]: props.height === '2.4rem',
            [css.cardColorSensitiveBG]: (props.theme === 'colorSensitive'),
            [css.cardMini]: (props.theme === 'mini'),
            [css.cardJag]: (props.theme === 'jaguar'),
            [css.cardLM]: (props.theme === 'lexusMonogram'),
            [css.cardCadillac]: (props.theme === 'cadillac'),
            [css.cardChevrolet]: (props.theme === 'chevrolet'),
            [css.cardHonda]: (props.theme === 'honda'),
            [css.cardBuick]: (props.theme === 'buick'),
            [css.cardBMW]: (props.theme === 'bmw'),
            [css.cardIN]: props.theme === 'infiniti',
            [css.cardHyundai]: props.theme === 'hyundai',
            [css.cardNissan]: (props.theme === 'nissan'),
            [css.cardMB]: props.theme === 'mercedesBenz',
            [css.cardMazda]: (props.theme === 'mazda'),
            [css.cardAcura]: (props.theme === 'acura'),
            [css.cardGenesis]: (props.theme === 'genesis'),
        },
    );

    const otherCardStyle = classNames(
        cardStyle,
        {
            [css.lgOthrCard]: (!height || !width),
            [css.smlOthrCard]: props.height === '2.4rem',
        },
    );

    const otherPropertyHandler = useCallback((value: string) => {
        if (value !== 'default') {
            setOtherProperty(value);
            setMenuOpenFlag(false);
            click(value);
            const ascMenuInteractionInp : ascMenuInteractionInput = {
                pageType: 'service',
                elementText: value,
                elementSubtype: 'dropdown',
                elementType: 'other',
                eventAction: 'click',
            };
            ascMenuInteraction(ascMenuInteractionInp);
        }
    }, [click]);
    let dialogHeader = strings.SelectMake;
    let useDropDown = makeDropdownList;
    if (id === 'Other Year') {
        useDropDown = yearDropdownList;
        dialogHeader = strings.SelectTheYear;
    }

    const onFocusHandler = useCallback(() => {
        if (!selectOpen) {
            const ascMenuInteractionInp : ascMenuInteractionInput = {
                pageType: 'service',
                elementText: '',
                elementSubtype: 'dropdown',
                elementType: 'other',
                eventAction: 'click',
            };
            ascMenuInteraction(ascMenuInteractionInp);
            setSelectOpen(true);
        }
    }, [selectOpen]);

    const interactionHandler = useCallback((e: any, color?: string) => {
        const newVehicle = {
            id: '',
            vin: props.options?.vin ?? '',
            makeCode: props.options?.makeCode ?? '',
            make: props.options?.make ?? '',
            model: props.options?.model ?? '',
            imagePath: '',
            year: props.options?.year ?? '',
            color: props.options?.year ?? '',
            style: props.options?.trim ?? '',
            prevMileage: 0,
            prevRoDate: '',
            nextAppt: '',
            lastAdv: '',
            lastAdvName: '',
            lastAdvImage: '',
            lastTrans: '',
            lastTransLit: '',
            nameId: '',
        };
        const ascCtaInteractionInp : ascCtaInteractionInput = {
            pageType: 'service',
            elementText: e.target.id === 'closeBtn' ? 'X' : strings.Other,
            elementColor: color ? color : '',
            elementOrder: '',
            elementType: 'popup',
            elementSubType: e.target.id === 'closeBtn' ? 'nav_button' : 'other_buttons',
            eventAction: 'click',
            eventActionResult: !menuOpenFlag ? 'open' : 'close',
            linkUrl: '',
        };
        ascCtaInteraction(ascCtaInteractionInp, e, [newVehicle]);
        const ascElementConfigurationInp: ascElementConfigurationInput = {
            pageType: 'service',
            elementText: strings.Other,
            elementType: 'item_details',
            elementColor: color ? color : '',
            eventAction: 'click',
            eventActionResult: !menuOpenFlag ? 'open' : 'close',
            linkUrl: '',
        };
        ascElementConfiguration(ascElementConfigurationInp, e);
    }, [props.options, menuOpenFlag]);

    const iconRemoveHandler = useCallback((e: any) => {
        setMenuOpenFlag(false);
        let elementColor = '';
        if (e?.target) {
            elementColor = getElementColor(e, 'color');
        }
        interactionHandler(e, elementColor);
    }, [interactionHandler]);

    const otherPropertyCard = (
        <div id='otherPropertyCard'>
            <Button
                id={id + 'btn'}
                type={'custom'}
                onClick={(e: any) => {
                    setMenuOpenFlag(true);
                    interactionHandler(e);
                }}
                variant='atext'
            >
                <div
                    className={otherCardStyle}
                    id={id}
                >
                    <small className={othrLblStyle}>
                        {otherLabel}
                    </small>
                </div>
            </Button>
            <Dialog
                id='otherPropertyDialog'
                cssClasses={{
                    content: css.content,
                    paper: css.paper,
                    header: css.LightBoxHeader,
                }}
                isOpen={menuOpenFlag}
                anchorOrigin={{
                    vertical: 'top',
                }}
                header={dialogHeader}
                hideSave={true}
                hideCancel={true}
                disableUpperCase={true}
                onCancel={(e: any) => {
                    setMenuOpenFlag(false);
                    if (e?.charCode === 0) {
                        interactionHandler(e);
                    }
                }}
                onBackDropClick={(e: any) => {
                    setMenuOpenFlag(false);
                    interactionHandler(e);
                }}
                width={'full'}>
                <div className={css.headerbox}>
                    {dialogHeader}
                    <div className={css.headerIcon}>
                        <IconRemove id='closeBtn' onClick={(e: any) => iconRemoveHandler(e)}/>
                    </div>
                </div>
                <div onMouseDown={onFocusHandler} id='selectListContainer'>
                    <SelectList
                        id='otherSelectList'
                        value={otherProperty}
                        dropDownList={useDropDown}
                        disableUnderline
                        size='full'
                        onChange={(_, otherProperty) => otherPropertyHandler(otherProperty)}
                    />
                </div>
            </Dialog>
        </div>
    );

    let imgDisplay = <></>;
    const [hasImage, setHasImage] = useState<boolean>(false);
    if (pane) {
        if (pane === 'Models') {
            imgDisplay = <VehicleModelImages year={year} make={make} model={id} type='thumb' Itype={props?.Itype} />;
        }
        if (pane === 'Makes') {
            imgDisplay = <VehicleMakeImages make={id} background={cardClicked ||
                (background === 'dark' && props.theme !== 'infiniti') ?
                'dark' : 'light'} theme={props.theme} setHasImage={setHasImage}/>;
        }
    }

    let smallLitStyle = classNames (
        css.smallLit,
        {
            [css.smallLitNoImg]: (pane === 'Makes' && (!hasImage || transLit.toLowerCase() === 'porsche')),
            [css.smallLitFontWeight400]: props.theme === 'honda' || props.theme === 'infiniti',
            [css.smallLitFord]: props.theme === 'ford',
            [css.smallLitNissan]: props.theme === 'nissan',
            [css.smallLitMazda]: props.theme === 'mazda',
            [css.smallLitAcura]: props.theme === 'acura',
            [css.smallLitGenesis]: props.theme === 'genesis',
        },
    );

    if (props.height === '2.4rem') {
        smallLitStyle = css.smallLit2;
    }
    const defaultPropertyCard = (
        <div id='defaultPropertyCard' onMouseEnter={() => setBackground('dark')} onMouseLeave={() => setBackground('light')}>
            <Button
                id={id + 'DefaultBtn'}
                onClick={() => {
                    click(id);
                    setOtherProperty('default');
                }}
                variant='atext'
                // classNames={css.btnClass}
                tooltip={`${strings.Select} ${transLit}`}
            >
                <div
                    id={id}
                    className={cardStyle}
                    style={{ height: `${height}`, width: `${width}` }}
                >
                    {imgDisplay}
                    <small
                        id={id}
                        className={smallLitStyle}
                    >
                        {transLit}
                    </small>
                </div>
            </Button>
        </div>
    );

    return (id.slice(0, 5) === 'Other' ? otherPropertyCard : defaultPropertyCard);
};

export default VehicleCard;